
import Vue from 'vue'
import SchoolOrderDetails from './SchoolOrderDetails.vue'
import SelectionAccordion, { SelectionAccordionOption } from './SelectionAccordion.vue'

export default Vue.extend({
   name: 'OrderType',
   computed: {
      orderType(): string {
         return this.isPersonalOrder ? 'personal' : 'school'
      },
      orderTypeOptions(): SelectionAccordionOption[] {
         return [
            { name: 'Personal Order', value: 'personal' },
            { name: 'School Order', value: 'school', component: SchoolOrderDetails },
         ]
      },
      isPersonalOrder(): boolean {
         return this.$store.state.purchase.IsPersonalOrder
      },
   },
   methods: {
      setOption(option: string) {
         this.setOrderType(option === 'personal')
      },
      async setOrderType(isPersonalOrder: boolean) {
         await this.$store.dispatch('setOrderType', isPersonalOrder)
      },
   },
   components: {
      SchoolOrderDetails,
      SelectionAccordion,
   },
})
